// extracted by mini-css-extract-plugin
export default {"header":"detail_header__6qLE5","header_title":"detail_header_title__ZoafI"};